import { Component, OnInit } from '@angular/core';
import { MbDialogRef, MbDialogFooter, MbDialogBody, MbIconModule, MbButton } from '@am/moebius';

@Component({
  selector: 'app-rate-not-found',
  standalone: true,
  imports: [MbDialogFooter, MbDialogBody, MbIconModule, MbButton],
  templateUrl: './rate-not-found.component.html',
  styleUrls: ['./rate-not-found.component.scss'],
})
export class RateNotFoundComponent implements OnInit {
  constructor(public dialogRef: MbDialogRef<RateNotFoundComponent>) {}

  ngOnInit(): void {}

  public refreshPage(): void {
    window.location.reload();
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }
}
